import {useContext} from 'react';

import {useTranslation} from 'react-i18next';

import {Box, Typography} from '@mui/material';

import {LanguageContext} from '../../../../../contexts/LanguageContext/LanguageContext';
import {Department} from '../../../profile/types';
import {DepartmentTargetProfilesSection} from '../../../workforce/components/DepartmentTargetProfiles/DepartmentTargetProfilesSection';

export interface Props {
  companyId: string;
  selectedDepartment: Department | null;
  isWorkforceModuleActive: boolean;
}

export const CompanyDepartmentDetailPane = ({companyId, selectedDepartment, isWorkforceModuleActive}: Props) => {
  const currentLanguage = useContext(LanguageContext);
  const {t} = useTranslation('translation', {keyPrefix: 'companySettings.departments.detail'});

  return (
    <Box
      sx={{
        border: 1,
        borderColor: 'divider',
        borderRadius: 2,
        p: 2,
        height: '100%',
        minHeight: 240,
      }}
    >
      {!selectedDepartment && (
        <Typography variant='body2' color='text.secondary'>
          {t('emptySelection')}
        </Typography>
      )}

      {selectedDepartment && (
        <>
          <Typography variant='h4' component='p' sx={{mb: 2}}>
            {selectedDepartment.name[currentLanguage]}
          </Typography>

          {isWorkforceModuleActive ? (
            <DepartmentTargetProfilesSection companyId={companyId} departmentId={selectedDepartment.resourceId} />
          ) : (
            <Typography variant='body2' color='text.secondary'>
              {t('workforceInactive')}
            </Typography>
          )}
        </>
      )}
    </Box>
  );
};
